import * as React from 'react';
import DocumentLink from './DocumentLink';
import { FileServiceGetFileDetailsResponse } from '../../services/api';
import { format } from 'date-fns';

export default function Note({ title, createdDate, createdBy, content, files = [] }: { title?: string, createdDate: Date, createdBy: string, content?: string, files?: FileServiceGetFileDetailsResponse[] }) {
  return (
    <div className="flex flex-col gap-2">
      <div className="flex flex-col">
        {title && (<div className="font-bold text0-xs">{title}</div>)}
        <div className="flex flex-wrap gap-2 text-2xs text-grey-8">
          <div>
            <span className="pi pi-user"></span> {createdBy}
          </div>
          <div>
            <span className="pi pi-calendar"></span> {format(createdDate, 'MM/dd/yyyy • H:mm:ss')}
          </div>
        </div>
      </div>

      {(!!content || files.length > 0) && (
        <div className="flex flex-col gap-4 p-4 rounded bg-grey-2">
          {content && (<div>{content}</div>)}

          {!!files.length && files.map((file, fileIndex) => {
            return (
              <div className="flex flex-wrap gap-2" key={fileIndex}>
                <DocumentLink fileId={file.fileId!} fileName={file.fileName!} />
              </div>
            )
          })}
        </div>
      )}
    </div>
  )  
}